
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"classAssignmentSubmissionPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ClassAssignmentsInput"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"classAssignment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignment"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignmentInstance"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignmentId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"maxScore"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mloName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dueOn"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"subjectCategory"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"language"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"attachment"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"path"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fileId"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"groupId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mloId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"gradeable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"attachmentRequired"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"commentRequired"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"maxStars"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"assignmentStats"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignedStudentsCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"submissionsCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"evaluatedCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"returnedCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"average"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"studentsSubmission"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SubmissionDetailsFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"groupedSubmissions"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GroupedSubmissionsFragment"},"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":908}};
    doc.loc.source = {"body":"#import \"../fragments/submissionDetailsFragment.graphql\"\n#import \"../fragments/groupedSubmissionsFragment.graphql\"\n\nquery classAssignmentSubmissionPage($input: ClassAssignmentsInput!) {\n  classAssignment(input: $input) {\n    assignment {\n      assignmentInstance {\n        assignmentId\n        title\n        maxScore\n        mloName\n        dueOn\n        subjectCategory\n        language\n        description\n        attachment {\n          fileName\n          path\n          fileId\n        }\n        groupId\n        mloId\n        gradeable\n        attachmentRequired\n        commentRequired\n        maxStars\n      }\n      assignmentStats {\n        assignedStudentsCount\n        submissionsCount\n        evaluatedCount\n        returnedCount\n        average\n      }\n    }\n    studentsSubmission {\n      ...SubmissionDetailsFragment\n    }\n\n    groupedSubmissions {\n      ...GroupedSubmissionsFragment\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("../fragments/submissionDetailsFragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("../fragments/groupedSubmissionsFragment.graphql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["classAssignmentSubmissionPage"] = oneQuery(doc, "classAssignmentSubmissionPage");
        
